"use client";

import { CheckCircle, Shield, Zap, Award, Users } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Input } from "@/components/ui/input";
export default function WhyChooseUs() {
  const benefits = [{
    icon: CheckCircle,
    title: "Luxury high-end home renovations",
    description: ""
  }, {
    icon: Shield,
    title: "Smart home integration",
    description: ""
  }, {
    icon: Zap,
    title: "Office and commercial fit-outs",
    description: ""
  }, {
    icon: Award,
    title: "Design & construction services",
    description: ""
  }, {
    icon: Users,
    title: "Architecture and interior design solutions",
    description: ""
  }];
  return <section id="why-choose-us" className="!m-0 !text-[hsl(32,29%,42%)] !bg-[rgba(138,109,76,0.3254901960784314)] flex flex-col items-center gap-12 overflow-hidden !py-24 !px-6 lg:!px-0 lg:flex-row">
      <div className="flex-1 w-full">
        <p className="text-[14px] font-medium uppercase tracking-[0.1em] text-[#8b6e4c] !mb-2 lg:!ml-[124px]">
          WHAT WE DO
        </p>
        <h2 className="font-display font-bold text-foreground !mb-[50px] lg:!ml-[124px] !text-5xl">Our Expertise</h2>
        <div className="!mb-[50px] lg:!mx-[124px] max-w-xl">
          <p className="text-muted-foreground leading-relaxed mb-8 !text-base">We provide a comprehensive range of services tailored to clients seeking refined results and professional execution:</p>
          <ul className="space-y-4 mb-8">
            {["Luxury high-end home renovations", "Smart home integration", "Office and commercial fit-outs", "Design & construction services", "Architecture and interior design solutions"].map((item, i) => <li key={i} data-index={i} className="flex items-center gap-3 text-foreground font-medium">
                <CheckCircle className="size-5 text-accent-dark" />
                {item}
              </li>)}
          </ul>
          <p className="text-muted-foreground leading-relaxed !text-base">Every service is delivered through a structured, transparent process — ensuring consistency and confidence at every stage.</p>
        </div>
        <div className="container mx-auto px-6 max-w-4xl"></div>
      </div>
      <div className="flex-1 w-full lg:pr-12">
        <img src="https://theksway.com/wp-content/uploads/2026/04/PXL_20260402_140747804.jpg" alt="Architectural expertise and luxury design detail" className="w-full h-auto rounded-lg shadow-strong object-cover max-h-[600px]" />
      </div>
    </section>;
}
function BenefitItem({
  icon: Icon,
  title,
  description,
  index
}: {
  icon: React.ElementType;
  title: string;
  description: string;
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.3,
    rootMargin: "0px"
  });
  return <div ref={ref} data-index={index} className="flex items-start gap-6 transition-all duration-700 ease-out ![margin:0px_0px_20px_0px]" style={{
    opacity: isVisible ? 1 : 0.1,
    transform: isVisible ? "translateX(0)" : "translateX(-2rem)"
  }}>
      <div className="flex-shrink-0">
        <Icon className="size-6 text-accent-dark" strokeWidth={1.5} />
      </div>
      <div className="flex-1">
        <h3 className="text-foreground text-2xl font-semibold mb-2 font-display">
          Luxury high-end home renovations
        </h3>
        {description && <p className="text-muted-foreground text-base leading-relaxed">{description}</p>}
      </div>
    </div>;
}